import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, ArrowLeft, CreditCard, RefreshCw } from 'lucide-react';
import { Header } from '../components/shared/Header';
import { Footer } from '../components/landing/Footer';
import { Button } from '../components/shared/Button';

export const PaymentFailedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');

  const title = reason === 'cancelled'
    ? t('payments.failure.cancelledTitle')
    : t('payments.failure.title');

  const subtitle = reason === 'cancelled'
    ? t('payments.failure.cancelledSubtitle')
    : t('payments.failure.subtitle');

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-red-50/30">
      <Header />

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center border border-gray-100">
          <div className="w-20 h-20 rounded-full bg-red-100 text-red-600 flex items-center justify-center mx-auto mb-6">
            <AlertTriangle className="w-10 h-10" />
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{title}</h1>
          <p className="text-lg text-gray-600 mb-8">{subtitle}</p>

          <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-8 text-left text-sm text-red-900">
            <p>{t('payments.failure.tip1')}</p>
            <p className="mt-1">{t('payments.failure.tip2')}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="primary"
              size="large"
              icon={<CreditCard className="w-5 h-5" />}
              onClick={() => navigate('/checkout?plan=level_bundle')}
            >
              {t('payments.failure.retry')}
            </Button>
            <Button
              variant="secondary"
              size="large"
              icon={<ArrowLeft className="w-5 h-5" />}
              onClick={() => navigate('/pricing')}
            >
              {t('payments.failure.backToPricing')}
            </Button>
          </div>

          <div className="mt-6">
            <Button
              variant="tertiary"
              size="small"
              icon={<RefreshCw className="w-4 h-4" />}
              onClick={() => navigate('/dashboard/subscription')}
            >
              {t('payments.failure.manageSubscription')}
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PaymentFailedPage;
